import type { HTMLAttributes } from "react";

export type BadgeTone = "good" | "warn" | "bad" | "neutral" | "accent";

const TONE_CLASSES: Record<BadgeTone, string> = {
  good: "bg-signal-good-bg text-signal-good",
  warn: "bg-signal-warn-bg text-signal-warn",
  bad: "bg-signal-bad-bg text-signal-bad",
  neutral: "bg-signal-neutral-bg text-signal-neutral",
  accent: "bg-accent-50 text-accent-600",
};

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

export function Badge({ tone = "neutral", className = "", children, ...rest }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium leading-none ${TONE_CLASSES[tone]} ${className}`}
      {...rest}
    >
      {children}
    </span>
  );
}
